__turbopack_context__.v({
  "articleNotPublished": "vars-module__bvfX8a__articleNotPublished",
  "articleStandard": "vars-module__bvfX8a__articleStandard",
});
